import React, { useEffect, useState } from "react";
import { RSelect } from "../Component";
import { QATypes } from "../../utils";

export const QATypeDropdown = ({ value, isMulti = false, className, onSelect, placeholder, ...props }) => {
  const [list, setList] = useState();

  useEffect(() => {
    setList(QATypes);
  }, []);

  return (
    <RSelect
      className={className}
      options={list ?? []}
      isMulti={isMulti}
      placeholder={placeholder}
      value={value ?? null}
      onChange={onSelect}
      {...props}
    />
  );
};
